import ErrorComponent from 'Components/ErrorComponent';
import Loading from 'Components/Loading';
import { calculateTimeDurationBetwnReports, handleServerResponse, checkValidString, machineryEnabled, saveEditForm, timeToDecimal, useSafeFormikContext, checkValidArray, checkValidObject, isFormUnchanged } from 'GenericForms/Helper';
import apiGlobal, { apiMedia } from 'global/api.global';
import env from 'environment_system/env_system';
import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query';
import { FileStatus, SpecialOpsConstant } from 'shared/constants';
import { queryKeyes } from 'shared/queryKeys';
import { Get } from 'VesselMaster/vesselMaster.hooks';
import * as Yup from 'yup';
import ReportDetailsHeader from 'Components/ReportDetailsHeader';
import { Card, CardHeader, Row, Col, Form, CardBody, Button, CardFooter, Input, Label, Modal } from 'reactstrap';
import { Formik, FieldArray, Field, FieldProps } from 'formik';
import SpOpFuelConsumptionComponent from './SpOpFuelConsumptionComponent';
import { TooltipMsg } from 'Components/ToolTipMessage';
import FormValuesDebug from 'utils/debugTools/FormValuesDebug';
import FourHrTableComponent from './FourHrTableComponent';
import SpOpEnergyConsumptionComponent from './SpOpEnergyConsumptionComponent';
import { commonValidationMessages } from 'Components/ValidationErrorMessages';
import ToolTip from 'Components/ToolTip';
import ReportingFileUpload from 'Components/ReportingFileUpload';
import { RootState } from 'index';
import { useDispatch, useSelector } from 'react-redux';
import { useDocumentTitle } from 'Components/useDocument.hooks';
import { getCurrentReportAction, getCurrentReportFilesAction } from 'Store/Generic/ReportingSlice';
import { useEditReport } from 'VesselReportingInfo/EditCompletedReports/EditReportProvider';
import Message from 'Components/Message';
interface SpecialOperationComponentProps {
    Operation: string;
    toggleDynamicTabs: (tabIndex: number) => void;
    energyField: string;
    FourHrTblHeader: any;
    setErrorMessage: (message: string) => void;
    spOpConstant: number;
    specialOpSettingObject: any;
}

const SpecialOperationComponent = ({
    Operation,
    toggleDynamicTabs,
    energyField,
    FourHrTblHeader,
    setErrorMessage,
    spOpConstant,
    specialOpSettingObject
}: SpecialOperationComponentProps) => {
    const { editReportBool, setPreviousTabIndex, previousEnggTabIndex } = useEditReport();
    /** State varibles start */
    const [fuelMachineQueryObj, setFuelMachineQueryObj] = useState<any>({
        variable: null,
        loadVariable: null
    });
    const [energyMachineQueryObj, setEnergyMachineQueryObj] = useState<any>({
        variable: null,
        loadVariable: null
    });
    const [withkWhMeter, setWithkWhMeter] = useState<Array<any>>([]);
    const [withoutkWhMeter, setWithoutkWhMeter] = useState<Array<any>>([]);
    const [applicableTimePeriod, setApplicableTimePeriod] = useState<Array<any>>([]);
    const [modal_backdrop, setmodal_backdrop] = useState(false);
    const [modalMachinery, setModalMachinery] = useState<any>({});
    const [modalIndex, setModalIndex] = useState<number>(null);
    const [logBookFile, setLogBookFile] = useState<Array<any>>([{}]);
    const [refreshKey, setRefreshKey] = useState<number>(0);
    const [formRefresh, setFormRefresh] = useState<number>(0);
    const DeleteFileObj: any = {
        file_name: null,
        file_path: null,
    }
    useDocumentTitle(`Special Operation ${Operation} - ecoSAIL`);
    const { VesselID, VoyageID, ReportID, CurrentReport, PreviousReport, reportingLoading, CurrentReportFiles, ConfigurationLimits, reportingError } = useSelector((state: RootState) => state.Reporting);
    const currentVesselReport = CurrentReport?.data?.vessel_reporting_information ?? null;
    const previousVesselReport = PreviousReport?.data?.vessel_reporting_information ?? null;
    const fuelConsumptionCurrentReport = CurrentReport?.data?.chief_engineer?.fuel_consumption ?? null;
    const spOpFuelConsumptionCurrentReport = CurrentReport?.data?.chief_engineer?.special_operation_fuel?.filter((item: any) => item.special_operation === spOpConstant) ?? null;
    const spOpEnergyConsumptionCurrentReport = CurrentReport?.data?.chief_engineer?.special_operation_energy?.filter((item: any) => item.special_operation === spOpConstant) ?? null;
    const spOp4HourReportingCurrentReport = CurrentReport?.data?.chief_engineer?.special_operation_4_hours_reporting?.filter((item: any) => item.special_operation === spOpConstant) ?? null;
    const fcElectricalReeferCurrentReport = CurrentReport?.data?.chief_engineer?.fc_electrical_reefer_details ?? null;
    const formikContext = useSafeFormikContext<any>();
    const editValues = formikContext?.values;
    const setEditValues = formikContext?.setValues;
    const editFuelConsumptionCurrentReport = editValues?.chief_engineer?.fuel_consumption ?? null;
    const editSubmit = formikContext?.submitForm;
    const editIsSubmitting = formikContext?.isSubmitting;
    const dispatch = useDispatch();
    const specialOperationFileUpload = checkValidArray(CurrentReportFiles?.SpecialOperationFileUpload) ? CurrentReportFiles?.SpecialOperationFileUpload.filter((item: any) =>
        item.special_operation === spOpConstant)[0] : null;
    const fuelTypes = ConfigurationLimits?.vessel_fuel_information ?? [];
    const fuelSettings = ConfigurationLimits?.vessel_fuel_setting ?? [];
    const edit4hrData = editValues ?
        editValues?.chief_engineer?.special_operation_4_hours_reporting?.filter((item: any) => item.special_operation === spOpConstant) :
        null;
    /** State variables end */

    /** Queries */
    /** Time periods for 4 hours table */
    const { data: TimePeriod, isLoading: TimePeriodLoading, isError: TimePeriodError }:
        { data: any[], isLoading: any, isError: any } = useQuery(
            [queryKeyes.vessel.TimePeriodObject.key],
            async () => {
                return await Get(queryKeyes.vessel.TimePeriodObject.url);
            },
            { staleTime: Infinity }
        )
    /** Max SFOC of vessel's auxiliary engines */
    const { data: AuxEngineMaxSFOC, isLoading: AuxEngineMaxSFOCLoading, isError: AuxEngineMaxSFOCError } = useQuery(
        [queryKeyes.vessel.AuxEngineMaxSFOC.key, VesselID],
        async () => {
            return await Get(queryKeyes.vessel.AuxEngineMaxSFOC.url(VesselID), VesselID);
        }, { staleTime: Infinity }
    );
    /** Special operation object from master */
    const { data: SpecialOpsObject, isLoading: SpecialOpsObjectLoading, isError: SpecialOpsObjectError }:
        { data: any, isLoading: any, isError: any } = useQuery(
            [queryKeyes.masters.SpecialOperationMaster.key, spOpConstant],
            async () => {
                return await Get(queryKeyes.masters.SpecialOperationMaster.url(spOpConstant), spOpConstant);
            }, { staleTime: Infinity }
        );
    /** Applicable fuel consumers */
    const { data: machineryFuelGroup, isLoading: machineryFuelGroupLoading, isError: machineryFuelGroupError } = useQuery(
        [fuelMachineQueryObj.variable, VesselID],
        async () => {
            return await fuelMachineQueryObj.loadVariable;
        }, { staleTime: Infinity, enabled: true }
    );
    /** Applicable energy consumers */
    const { data: machineryEnergyGroup, isLoading: machineryEnergyGroupLoading, isError: machineryEnergyGroupError } = useQuery(
        [energyMachineQueryObj.variable, VesselID],
        async () => {
            return await energyMachineQueryObj.loadVariable;
        }, { staleTime: Infinity, enabled: true }
    );
    /** Queries end */

    /** Assign values to formik's fuelConsumption initial object */
    const getinitialFuelConsumption = () => {
        let arr: any[] = [];
        if (editReportBool) {
            if (checkValidArray(editValues?.chief_engineer?.special_operation_fuel)) {
                arr.push(...editValues?.chief_engineer?.special_operation_fuel);
                Object.values(SpecialOpsConstant)?.forEach((constant: number) => {
                    if (arr !== undefined &&
                        machineryFuelGroup !== undefined &&
                        fuelTypes !== undefined && specialOpSettingObject?.find((item: any) => constant === item?.sp_op_constant)?.applicable &&
                        !editValues?.chief_engineer?.special_operation_fuel?.some((item: any) => item.special_operation === constant)
                    ) {
                        machineryFuelGroup?.forEach((machine: any) => {
                            fuelTypes?.forEach((fuel: any) => {
                                arr.push({
                                    total_fuel_consumption: 0,
                                    special_operation: constant,
                                    vessel: VesselID,
                                    voyage_information: VoyageID,
                                    vessel_reporting_information: ReportID,
                                    vessel_machinery_fc_group: machine.vessel_machinery_fc_group,
                                    fuel_type: fuel.fuel_type
                                });
                            });
                        });
                    }
                })
            } else {

                Object.values(SpecialOpsConstant)?.forEach((constant: number) => {
                    if (arr !== undefined &&
                        machineryFuelGroup !== undefined &&
                        fuelTypes !== undefined &&
                        specialOpSettingObject?.find((item: any) => constant === item?.sp_op_constant &&
                            item?.sp_op_constant === spOpConstant)?.applicable
                    ) {
                        machineryFuelGroup?.forEach((machine: any) => {
                            fuelTypes?.forEach((fuel: any) => {
                                arr.push({
                                    total_fuel_consumption: 0,
                                    special_operation: constant,
                                    vessel: VesselID,
                                    voyage_information: VoyageID,
                                    vessel_reporting_information: ReportID,
                                    vessel_machinery_fc_group: machine.vessel_machinery_fc_group,
                                    fuel_type: fuel.fuel_type
                                });
                            });
                        });
                    }
                })
            }
            return arr;
        } else if (checkValidArray(spOpFuelConsumptionCurrentReport)) {
            return spOpFuelConsumptionCurrentReport;
        } else if (arr !== undefined &&
            machineryFuelGroup !== undefined &&
            fuelTypes !== undefined &&
            arr.length <= machineryFuelGroup?.length * fuelTypes?.length) {
            machineryFuelGroup?.forEach((machine: any) => {
                fuelTypes?.forEach((fuel: any) => {
                    arr.push({
                        total_fuel_consumption: 0,
                        special_operation: checkValidArray(SpecialOpsObject) ? SpecialOpsObject[0]?.id : null,
                        vessel: VesselID,
                        voyage_information: VoyageID,
                        vessel_reporting_information: ReportID,
                        vessel_machinery_fc_group: machine.vessel_machinery_fc_group,
                        fuel_type: fuel.fuel_type
                    });
                });
            });
            return arr;
        }
    }

    /** Assign values to formik's energy consumer's with functional kWh meter initial object */
    const getInitialFunctionalkWhMeterConsumption = () => {
        let obj: any[] = [];
        if (editReportBool) {
            if (checkValidArray(editValues?.chief_engineer?.special_operation_energy)) {
                obj.push(...editValues?.chief_engineer?.special_operation_energy);
                Object.values(SpecialOpsConstant)?.forEach((constant: number) => {
                    if (obj !== undefined && withkWhMeter !== undefined &&
                        specialOpSettingObject?.find((item: any) => constant === item?.sp_op_constant)?.applicable &&
                        !editValues?.chief_engineer?.special_operation_energy?.some((item: any) => item.special_operation === constant)
                    ) {
                        withkWhMeter.forEach((machine: any) => {
                            obj.push({
                                is_kwh_meter_not_functional: false,
                                energy_consumed: 0,
                                equivalent_fuel_consumption: 0,
                                special_operation: constant,
                                vessel: VesselID,
                                voyage_information: VoyageID,
                                vessel_reporting_information: ReportID,
                                vessel_machinery_ec_group: machine.vessel_machinery_ec_group,
                                vessel_machinery_ec_group_name: machine.vessel_machinery_ec_group_name
                            });
                        });
                    }
                })
            } else {
                Object.values(SpecialOpsConstant)?.forEach((constant: number) => {
                    if (obj !== undefined && withkWhMeter !== undefined &&
                        specialOpSettingObject?.find((item: any) => constant === item?.sp_op_constant &&
                            item?.sp_op_constant === spOpConstant)?.applicable
                    ) {
                        withkWhMeter.forEach((machine: any) => {
                            const matchedRecord = PreviousReport?.data?.chief_engineer?.special_operation_energy?.find((sensor: any) => sensor.vessel_machinery_ec_group === machine.id);
                            obj.push({
                                is_kwh_meter_not_functional: matchedRecord?.is_kwh_meter_not_functional ?? false,
                                energy_consumed: 0,
                                equivalent_fuel_consumption: 0,
                                special_operation: constant,
                                vessel: VesselID,
                                voyage_information: VoyageID,
                                vessel_reporting_information: ReportID,
                                vessel_machinery_ec_group: machine.vessel_machinery_ec_group,
                                vessel_machinery_ec_group_name: machine.vessel_machinery_ec_group_name
                            });
                        });
                    }
                })
            }
            return obj;
        } else if (checkValidArray(spOpEnergyConsumptionCurrentReport)) {
            return spOpEnergyConsumptionCurrentReport;
        } else if (obj !== undefined &&
            withkWhMeter !== undefined &&
            obj.length <= withkWhMeter.length) {
            withkWhMeter.map((machine: any) => {
                const matchedRecord = PreviousReport?.data?.chief_engineer?.special_operation_energy?.find((sensor: any) => sensor.vessel_machinery_ec_group === machine.id);
                obj.push({
                    is_kwh_meter_not_functional: matchedRecord?.is_kwh_meter_not_functional ?? false,
                    energy_consumed: 0,
                    equivalent_fuel_consumption: 0,
                    special_operation: checkValidArray(SpecialOpsObject) ? SpecialOpsObject[0]?.id : null,
                    vessel: VesselID,
                    voyage_information: VoyageID,
                    vessel_reporting_information: ReportID,
                    vessel_machinery_ec_group: machine.vessel_machinery_ec_group,
                    vessel_machinery_ec_group_name: machine.vessel_machinery_ec_group_name
                });
                return machine;
            });
            return obj;
        }
    }

    /** Assign values to formik's energy consumer's with non functional kWh meter initial object */
    const getInitialNonFunctionalkWhMeterConsumption = () => {
        let arr: any[] = [];
        if (spOpConstant === SpecialOpsConstant.REEFER_CONTAINER) {
            if (checkValidArray(fcElectricalReeferCurrentReport)) {
                return fcElectricalReeferCurrentReport;
            } else {
                arr.push({
                    reefer_days_at_sea: 'No data available',
                    reefer_days_in_port: 'No data available',
                    equivalent_fuel_consumption: 'No data available',
                    fc_electrical_reefer: 'No data available',
                })
                return arr;
            }
        } else if (checkValidArray(editValues?.chief_engineer?.special_operation_energy) &&
            checkValidArray(edit4hrData)) {
            withkWhMeter.flatMap((machine: any) => {
                edit4hrData?.filter((item: any) => item.vessel_machinery_ec_group === machine.vessel_machinery_ec_group)
                    ?.forEach((obj: any) => {
                        if (!arr.includes(obj)) {
                            arr.push(obj);
                        }
                    });
                return "";
            });
            return arr;
        } else if (checkValidArray(spOp4HourReportingCurrentReport) && checkValidArray(spOpEnergyConsumptionCurrentReport)) {
            withkWhMeter?.flatMap((machine: any) => {
                spOp4HourReportingCurrentReport?.filter((item: any) =>
                    item.vessel_machinery_ec_group === machine.vessel_machinery_ec_group && item.special_operation === spOpConstant)
                    ?.forEach((obj: any) => {
                        if (!arr.includes(obj)) {
                            arr.push(obj);
                        }
                    });
                return "";
            })
            return arr;
        } else if (
            arr !== undefined && withkWhMeter !== undefined &&
            checkValidArray(applicableTimePeriod) && applicableTimePeriod[0]?.id > 0 && arr.length <= withkWhMeter.length) {
            withkWhMeter.flatMap((machine: any) => {
                applicableTimePeriod.map((time: any) => {
                    arr.push({
                        hours_of_consumption: 0,
                        v: 0,
                        i: 0,
                        pf: 0,
                        w: 0,
                        special_operation: checkValidArray(SpecialOpsObject) ? SpecialOpsObject[0]?.id : null,
                        vessel_machinery_ec_group: machine.vessel_machinery_ec_group,
                        vessel: VesselID,
                        voyage_information: VoyageID,
                        vessel_reporting_information: ReportID,
                        period: time.id,
                        machine_name: machine.vessel_machinery_ec_group_name,
                        time_period: time.period
                    })
                    return time;
                })
                return machine;
            })
            return arr
        }
    }

    /** Assign values to formik's energy consumer's without kWh meter initial object */
    const getInitialWithoutkWhMeterConsumption = () => {
        let obj: any[] = [];
        if (spOpConstant === SpecialOpsConstant.REEFER_CONTAINER) {
            if (checkValidArray(fcElectricalReeferCurrentReport)) {
                return fcElectricalReeferCurrentReport;
            } else {
                obj.push({
                    reefer_days_at_sea: 'No data available',
                    reefer_days_in_port: 'No data available',
                    equivalent_fuel_consumption: 'No data available',
                    fc_electrical_reefer: 'No data available',
                })
                return obj;
            }
        } else if (checkValidArray(edit4hrData)) {
            withoutkWhMeter?.flatMap((machine: any) => {
                edit4hrData?.filter((item: any) =>
                    item.vessel_machinery_ec_group === machine.vessel_machinery_ec_group)
                    ?.forEach((fourHr: any) => {
                        if (!obj.includes(fourHr)) {
                            obj.push(fourHr);
                        }
                    });
                return "";
            })
            return obj;
        } else if (checkValidArray(spOp4HourReportingCurrentReport)) {
            withoutkWhMeter.flatMap((machine: any) => {
                spOp4HourReportingCurrentReport?.filter((item: any) =>
                    item.vessel_machinery_ec_group === machine.vessel_machinery_ec_group && item.special_operation === spOpConstant)
                    ?.forEach((fourHr: any) => {
                        if (!obj.includes(fourHr)) {
                            obj.push(fourHr);
                        }
                    })
                return "";
            })
            return obj;
        } else if (obj !== undefined && checkValidArray(applicableTimePeriod) && obj.length <= withoutkWhMeter.length) {
            withoutkWhMeter.flatMap((machine: any) => {
                applicableTimePeriod.map((time: any) => {
                    obj.push({
                        hours_of_consumption: 0,
                        v: 0,
                        i: 0,
                        pf: 0,
                        w: 0,
                        special_operation: checkValidArray(SpecialOpsObject) ? SpecialOpsObject[0]?.id : null,
                        vessel_machinery_ec_group: machine.vessel_machinery_ec_group,
                        vessel: VesselID,
                        voyage_information: VoyageID,
                        vessel_reporting_information: ReportID,
                        period: time.id,
                        machine_name: machine.vessel_machinery_ec_group_name,
                        time_period: time.period
                    });
                    return time;
                });
                return machine;
            });
            return obj;
        }
    }

    /** Assign values to formik's special operation log book upload initial object */
    const getInitialLogBookUpload = () => {
        if (checkValidObject(specialOperationFileUpload)) {
            return specialOperationFileUpload;
        } else {
            return ({
                file_name: null,
                status: FileStatus.PENDING,
                special_operation: checkValidArray(SpecialOpsObject) ? SpecialOpsObject[0]?.id : null,
                vessel: VesselID,
                vessel_reporting_information: ReportID,
                voyage_information: VoyageID
            })
        }
    }

    /** useEffect start */
    useEffect(() => {
        const loadQueryData = () => {
            let fuelMachineObj: any = {
                variable: null,
                loadVariable: null
            }
            let energyMachineObj: any = {
                variable: null,
                loadVariable: null
            }
            switch (Operation) {
                case "Cargo Cooling":
                    /** for fuel consumer machinery group query */
                    fuelMachineObj.variable = (queryKeyes.vessel.CargoCoolingFuelMachineries.key);
                    fuelMachineObj.loadVariable = Get(queryKeyes.vessel.CargoCoolingFuelMachineries.url(VesselID));
                    setFuelMachineQueryObj(fuelMachineObj);
                    /** for energy consumer machinery group query */
                    energyMachineObj.variable = (queryKeyes.vessel.CargoCoolingWithkWhMachineries.key);
                    energyMachineObj.loadVariable = Get(queryKeyes.vessel.CargoCoolingWithkWhMachineries.url(VesselID));
                    setEnergyMachineQueryObj(energyMachineObj);
                    break;
                case "Cargo Discharging":
                    /** for fuel consumer machinery group query */
                    fuelMachineObj.variable = (queryKeyes.vessel.CargoDischargingFuelMachineries.key);
                    fuelMachineObj.loadVariable = Get(queryKeyes.vessel.CargoDischargingFuelMachineries.url(VesselID));
                    setFuelMachineQueryObj(fuelMachineObj);
                    /** for energy consumer machinery group query */
                    energyMachineObj.variable = (queryKeyes.vessel.CargoDischargingWithkWhMachineries.key);
                    energyMachineObj.loadVariable = Get(queryKeyes.vessel.CargoDischargingWithkWhMachineries.url(VesselID));
                    setEnergyMachineQueryObj(energyMachineObj);
                    break;
                case "Cargo Heating":
                    /** for fuel consumer machinery group query */
                    fuelMachineObj.variable = (queryKeyes.vessel.CargoHeatingFuelMachineries.key);
                    fuelMachineObj.loadVariable = Get(queryKeyes.vessel.CargoHeatingFuelMachineries.url(VesselID));
                    setFuelMachineQueryObj(fuelMachineObj);
                    /** for energy consumer machinery group query */
                    energyMachineObj.variable = (queryKeyes.vessel.CargoHeatingWithkWhMachineries.key);
                    energyMachineObj.loadVariable = Get(queryKeyes.vessel.CargoHeatingWithkWhMachineries.url(VesselID));
                    setEnergyMachineQueryObj(energyMachineObj);
                    break;
                case "Cargo Reliquification":
                    /** for fuel consumer machinery group query */
                    fuelMachineObj.variable = (queryKeyes.vessel.CargoReliquificationFuelMachineries.key);
                    fuelMachineObj.loadVariable = Get(VesselID ? queryKeyes.vessel.CargoReliquificationFuelMachineries.url(VesselID) : '');
                    setFuelMachineQueryObj(fuelMachineObj);
                    /** for energy consumer machinery group query */
                    energyMachineObj.variable = (queryKeyes.vessel.CargoReliquificationWithkWhMachineries.key);
                    energyMachineObj.loadVariable = Get(queryKeyes.vessel.CargoReliquificationWithkWhMachineries.url(VesselID));
                    setEnergyMachineQueryObj(energyMachineObj);
                    break;
                case "Reefer Container":
                    /** for fuel consumer machinery group query */
                    fuelMachineObj.variable = (queryKeyes.vessel.ReeferContainerFuelMachineries.key);
                    fuelMachineObj.loadVariable = Get(queryKeyes.vessel.ReeferContainerFuelMachineries.url(VesselID));
                    setFuelMachineQueryObj(fuelMachineObj);
                    /** for energy consumer machinery group query */
                    energyMachineObj.variable = (queryKeyes.vessel.ReeferContainerWithkWhMachineries.key);
                    energyMachineObj.loadVariable = Get(queryKeyes.vessel.ReeferContainerWithkWhMachineries.url(VesselID));
                    setEnergyMachineQueryObj(energyMachineObj);
                    break;
                // case "Tank Cleaning":
                //     /** for fuel consumer machinery group query */
                //     fuelMachineObj.variable = (queryKeyes.vessel.TankCleaningFuelMachineries.key);
                //     fuelMachineObj.loadVariable = loadTankCleaningFuel(VesselID);
                //     setFuelMachineQueryObj(fuelMachineObj);
                //     /** for energy consumer machinery group query */
                //     energyMachineObj.variable = (queryKeyes.vessel.TankCleaningWithkWhMachineries.key);
                //     energyMachineObj.loadVariable = loadTankCleaningWithkWh(VesselID);
                //     setEnergyMachineQueryObj(energyMachineObj);
                //     break;
            }
            setFormRefresh(formRefresh + 1);
        }; loadQueryData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Operation, VesselID, ReportID])
    /** Distinguish energy consumers based on kWh meter's presence */
    useEffect(() => {
        if (machineryEnergyGroup?.length > 0 && machineryEnergyGroup[0].id > 0) {
            setWithkWhMeter(machineryEnergyGroup.filter((item: any) => item[energyField] === true));
            setWithoutkWhMeter(machineryEnergyGroup.filter((item: any) => item[energyField] === false));
        }
        setFormRefresh(formRefresh + 1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [machineryEnergyGroup, VesselID, energyField])
    /** Show applicable time periods */

    useEffect(() => {
        let array: any[] = [];
        let timeDurationHr = calculateTimeDurationBetwnReports(previousVesselReport?.reporting_time_utc, currentVesselReport?.reporting_time_utc) / 60;
        let timeDuration = Math.floor(Math.abs(timeDurationHr / 4))
        if (currentVesselReport && previousVesselReport && timeDuration >= 0 && TimePeriod && TimePeriod?.length > 0) {
            for (let i = 0; i <= timeDuration; i++) {
                let index;
                if (i <= 5) {
                    index = i;
                } else {
                    index = (i - 6) % 6;
                }
                const previousVesselReportDateTime = new Date(previousVesselReport.local_time);
                const currRecordDateTime = new Date(currentVesselReport.local_time);
                const previousVesselReportDate = new Date(previousVesselReport.local_time?.toString().substring(0, 10));
                const currRecordDate = new Date(currentVesselReport?.local_time?.toString().substring(0, 10));
                const previousVesselReportPeriodEnd = new Date(`${previousVesselReport?.local_time?.toString()?.substring(0, 11)}${TimePeriod[index]?.period?.toString()?.substring(5, 7)}:${TimePeriod[index]?.period?.toString()?.substring(7, 9)}:00Z`);
                const currRecordPeriodEnd = new Date(`${currentVesselReport?.local_time?.toString()?.substring(0, 11)}${TimePeriod[index]?.period?.toString()?.substring(5, 7)}:${TimePeriod[index]?.period?.toString()?.substring(7, 9)}:00Z`);
                if (previousVesselReportDate.toISOString() !== currRecordDate.toISOString()) {
                    if (TimePeriod[index]?.id <= 3) {
                        if (i <= 3) {
                            if (previousVesselReportPeriodEnd.toISOString() >= previousVesselReportDateTime.toISOString()) {
                                array.push(TimePeriod[index]);
                            }
                        } else {
                            if (currRecordDateTime.toISOString() >= currRecordPeriodEnd.toISOString()) {
                                array.push(TimePeriod[index]);
                            }
                        }
                    } else {
                        if (currRecordDateTime?.toISOString() >= currRecordPeriodEnd?.toISOString()) {
                            array.push(TimePeriod[index]);
                        }
                    }
                } else {
                    if (timeDuration === 0) {
                        array.push(TimePeriod?.filter((item: any) =>
                            (parseInt(item?.period?.toString()?.substring(0, 2)) <
                                timeToDecimal(previousVesselReport?.local_time?.toString()?.substring(11, 16)))
                            && (timeToDecimal(currentVesselReport?.local_time?.toString()?.substring(11, 16)) ===
                                parseInt(item?.period?.toString()?.substring(5, 7)))
                        )[0])
                    } else if (timeDuration === 1) {
                        const applicablePeriod = TimePeriod?.filter((item: any) =>
                            (parseInt(item?.period?.toString()?.substring(0, 2)) <=
                                timeToDecimal(previousVesselReport?.local_time?.toString()?.substring(11, 16)))
                            && (timeToDecimal(currentVesselReport?.local_time?.toString()?.substring(11, 16)) <=
                                parseInt(item?.period?.toString()?.substring(5, 7)))
                        )[0];
                        if (!array.includes(applicablePeriod)) {
                            array.push(applicablePeriod);
                        }
                    } else if (timeDuration > 1) {
                        const applicablePeriod = TimePeriod?.filter((item: any) =>
                            (parseInt(item?.period?.toString()?.substring(5, 7)) >
                                timeToDecimal(previousVesselReport?.local_time?.toString()?.substring(11, 16)))
                            && (timeToDecimal(currentVesselReport?.local_time?.toString()?.substring(11, 16)) >=
                                parseInt(item?.period?.toString()?.substring(5, 7)))
                        );
                        if (!array.includes(applicablePeriod)) {
                            array = applicablePeriod;
                        }
                    }
                }
            }
        }
        setApplicableTimePeriod(array);
        setFormRefresh(formRefresh + 1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [previousVesselReport, currentVesselReport, TimePeriod, VesselID, VoyageID, ReportID, spOpConstant])
    /** useEffect end */
    useEffect(() => {
        // SpecialOperationFormik.initialValues.logBook = getInitialLogBookUpload();
        SpecialOperationFormik.initialValues.fuelConsumption = getinitialFuelConsumption();
        SpecialOperationFormik.initialValues.withkWhMeter.functional = getInitialFunctionalkWhMeterConsumption();
        SpecialOperationFormik.initialValues.withkWhMeter.nonfunctional = getInitialNonFunctionalkWhMeterConsumption();
        SpecialOperationFormik.initialValues.withoutkWhMeter = getInitialWithoutkWhMeterConsumption();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [SpecialOpsObject, fuelConsumptionCurrentReport, fuelSettings, machineryFuelGroup, machineryEnergyGroup, withkWhMeter,
        applicableTimePeriod, withoutkWhMeter, spOpFuelConsumptionCurrentReport, fcElectricalReeferCurrentReport,
        spOpEnergyConsumptionCurrentReport, spOp4HourReportingCurrentReport, VesselID, VoyageID, ReportID])
    /** useEffect end */

    /** Special Operation's formik object */
    const SpecialOperationFormik = {
        initialValues: {
            logBook: getInitialLogBookUpload(),
            fuelConsumption: getinitialFuelConsumption(),
            withkWhMeter: {
                functional: getInitialFunctionalkWhMeterConsumption(),
                nonfunctional: getInitialNonFunctionalkWhMeterConsumption(),
            },
            withoutkWhMeter: getInitialWithoutkWhMeterConsumption(),
        },
        validationScehma: Yup.object({
            fuelConsumption: Yup.array(
                Yup.object({
                    total_fuel_consumption:
                        Yup.string().matches(/^(0|[1-9]\d*)(\.\d+)?$/, commonValidationMessages.validNumber).required(commonValidationMessages.required),
                }).test(function (value: any) {
                    const fuelConsumption: any = (this.parent) ? this.parent : [];
                    const index = fuelConsumption?.indexOf(value);
                    for (const item of (!editReportBool ? fuelConsumptionCurrentReport : editFuelConsumptionCurrentReport)) {
                        if (value.vessel_machinery_fc_group === item.vessel_machinery_fc_group &&
                            value.fuel_type === item.fuel_type) {
                            if (parseFloat(value.total_fuel_consumption) > item.fuel_consumed) {
                                return new Yup.ValidationError(
                                    `Fuel consumption should be equal to or less than that mentioned in the fuel consumption form (${item.fuel_consumed} mt)`,
                                    undefined,
                                    `fuelConsumption.${index}.total_fuel_consumption`
                                );
                            }
                        }
                    }
                    return true;
                })
            ),
            withkWhMeter: Yup.object({
                functional: Yup.array(
                    Yup.object({
                        energy_consumed: Yup.string()
                            .required(commonValidationMessages.required)
                            .matches(
                                /^[0-9]{0,5}(\.[0-9]{1,4})?$/,
                                `${commonValidationMessages.before5after4}`
                            ),
                    })
                ),
                nonfunctional: Yup.array(
                    Yup.object({})
                        .test("nonFunctionalValidation", "", function (value: any) {
                            const nonFunctional = this.parent ?? [];
                            const index = nonFunctional.indexOf(value);
                            const allValues = this.options?.context;
                            const errors: Yup.ValidationError[] = [];
                            const functional = allValues?.withkWhMeter?.functional?.find(
                                (item: any) => item.vessel_machinery_ec_group === value.vessel_machinery_ec_group
                            );
                            if (
                                SpecialOpsObject &&
                                SpecialOpsObject[0]?.constant !== SpecialOpsConstant.REEFER_CONTAINER &&
                                functional?.is_kwh_meter_not_functional
                            ) {
                                if (!checkValidString(String(value.hours_of_consumption))) {
                                    errors.push(
                                        this.createError({
                                            path: `withkWhMeter.nonfunctional.${index}.hours_of_consumption`,
                                            message: commonValidationMessages.required,
                                        })
                                    );
                                }
                                if (
                                    !/^(?:[0-3](?:\.\d{1,2})?|4(?:\.0{1,2})?)$/.test(String(value.hours_of_consumption))
                                ) {
                                    errors.push(
                                        this.createError({
                                            path: `withkWhMeter.nonfunctional.${index}.hours_of_consumption`,
                                            message:
                                                "Please enter a number between 0 and 4 with up to 2 digits after the decimal point",
                                        })
                                    );
                                }
                                if (
                                    !/^\d+(\.\d+)?$/.test(String(value.v))
                                ) {
                                    errors.push(
                                        this.createError({
                                            path: `withkWhMeter.nonfunctional.${index}.v`,
                                            message:
                                                "Please enter a number",
                                        })
                                    );
                                }
                                if (
                                    !/^\d+(\.\d+)?$/.test(String(value.i))
                                ) {
                                    errors.push(
                                        this.createError({
                                            path: `withkWhMeter.nonfunctional.${index}.i`,
                                            message:
                                                "Please enter a number",
                                        })
                                    );
                                } if (
                                    !/^\d+(\.\d+)?$/.test(String(value.pf))
                                ) {
                                    errors.push(
                                        this.createError({
                                            path: `withkWhMeter.nonfunctional.${index}.pf`,
                                            message:
                                                "Please enter a number",
                                        })
                                    );
                                }
                                if (!checkValidString(String(value.v))) {
                                    errors.push(
                                        this.createError({
                                            path: `withkWhMeter.nonfunctional.${index}.v`,
                                            message: commonValidationMessages.required,
                                        })
                                    );
                                }
                                if (!checkValidString(String(value.i))) {
                                    errors.push(
                                        this.createError({
                                            path: `withkWhMeter.nonfunctional.${index}.i`,
                                            message: commonValidationMessages.required,
                                        })
                                    );
                                }
                                if (!checkValidString(String(value.pf))) {
                                    errors.push(
                                        this.createError({
                                            path: `withkWhMeter.nonfunctional.${index}.pf`,
                                            message: commonValidationMessages.required,
                                        })
                                    );
                                }
                                if (errors.length) {
                                    throw new Yup.ValidationError(errors);
                                }
                            }
                            return true;
                        })
                )
            }),
            withoutkWhMeter: Yup.array(
                Yup.object({})
                    .test("withoutkWhMeterValidation", "", function (value: any) {
                        const withoutkWhMeter = this.parent ?? [];
                        const index = withoutkWhMeter.indexOf(value);
                        const errors: Yup.ValidationError[] = [];
                        if (
                            SpecialOpsObject &&
                            SpecialOpsObject[0]?.constant !== SpecialOpsConstant.REEFER_CONTAINER &&
                            checkValidArray(withoutkWhMeter)
                        ) {
                            if (!checkValidString(String(value.hours_of_consumption))) {
                                errors.push(
                                    this.createError({
                                        path: `withoutkWhMeter.${index}.hours_of_consumption`,
                                        message: commonValidationMessages.required,
                                    })
                                );
                            }
                            if (
                                !/^(?:[0-3](?:\.\d{1,2})?|4(?:\.0{1,2})?)$/.test(String(value.hours_of_consumption))
                            ) {
                                errors.push(
                                    this.createError({
                                        path: `withoutkWhMeter.${index}.hours_of_consumption`,
                                        message:
                                            "Please enter a number between 0 and 4 with up to 2 digits after the decimal point",
                                    })
                                );
                            }
                            if (
                                !/^\d{1,2}(\.\d{1,4})?$/.test(String(value.v)) && checkValidArray(withoutkWhMeter)
                            ) {
                                errors.push(
                                    this.createError({
                                        path: `withoutkWhMeter.${index}.v`,
                                        message:
                                            "Please enter a number",
                                    })
                                );
                            }
                            if (
                                !/^\d{1,2}(\.\d{1,4})?$/.test(String(value.i)) && checkValidArray(withoutkWhMeter)
                            ) {
                                errors.push(
                                    this.createError({
                                        path: `withoutkWhMeter.${index}.i`,
                                        message:
                                            "Please enter a number",
                                    })
                                );
                            } if (
                                !/^\d{1,2}(\.\d{1,4})?$/.test(String(value.pf)) && checkValidArray(withoutkWhMeter)
                            ) {
                                errors.push(
                                    this.createError({
                                        path: `withoutkWhMeter.${index}.pf`,
                                        message:
                                            "Please enter a number",
                                    })
                                );
                            }
                            if (!checkValidString(String(value.v)) && checkValidArray(withoutkWhMeter)) {
                                errors.push(
                                    this.createError({
                                        path: `withoutkWhMeter.${index}.v`,
                                        message: commonValidationMessages.required,
                                    })
                                );
                            }
                            if (!checkValidString(String(value.i)) && checkValidArray(withoutkWhMeter)) {
                                errors.push(
                                    this.createError({
                                        path: `withoutkWhMeter.${index}.i`,
                                        message: commonValidationMessages.required,
                                    })
                                );
                            }
                            if (!checkValidString(String(value.pf)) && checkValidArray(withoutkWhMeter)) {
                                errors.push(
                                    this.createError({
                                        path: `withoutkWhMeter.${index}.pf`,
                                        message: commonValidationMessages.required,
                                    })
                                );
                            }
                            if (errors.length && checkValidArray(withoutkWhMeter)) {
                                throw new Yup.ValidationError(errors);
                            }
                        }
                        return true;
                    })
            )
        })
    }

    /** Open close modal */
    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    function tog_backdrop() {
        setmodal_backdrop(!modal_backdrop);
        removeBodyCss();
    }

    /** Special Operation submit function */
    const specialOperationSubmit = async (values: any, actions: any) => {
        const arrayResponse: any[] = [];
        let addUrl;
        /** Fuel consumption submit */
        if (values?.fuelConsumption[0]?.id) {
            values.fuelConsumption.forEach((val: any) => {
                addUrl = apiGlobal.put(`/special_operation_fuel/${val.id}/`, val);
                arrayResponse.push(addUrl);
            });
        } else {
            if (values?.fuelConsumption?.length > 0) {
                addUrl = await apiGlobal.post(`/special_operation_fuel/`, values.fuelConsumption);
                arrayResponse.push(addUrl);
            }
        }

        /** Energy consumption with kWh meter submit */
        if (values?.withkWhMeter?.functional?.length > 0 && values?.withkWhMeter.functional[0]?.id) {
            values.withkWhMeter.functional.forEach((val: any) => {
                addUrl = apiGlobal.put(`/special_operation_energy/${val.id}/`, val);
                arrayResponse.push(addUrl);
            });
        } else {
            if (values.withkWhMeter.functional?.length > 0) {
                addUrl = apiGlobal.post(`/special_operation_energy/`, values.withkWhMeter.functional);
                arrayResponse.push(addUrl);
            }
        }

        /** Energy consumption with non functional kWh meter submit */
        if (SpecialOpsObject && SpecialOpsObject[0]?.constant !== SpecialOpsConstant.REEFER_CONTAINER) {
            values?.withkWhMeter?.nonfunctional?.forEach((val: any) => {
                if (checkValidArray(spOp4HourReportingCurrentReport)) {
                    if (val.id === undefined) {
                        addUrl = apiGlobal.post('/special_operation_4_hours_reporting/', val);
                    } else {
                        addUrl = apiGlobal.put(`/special_operation_4_hours_reporting/${val.id}/`, val);
                    }
                } else {
                    addUrl = apiGlobal.post('/special_operation_4_hours_reporting/', val);
                }
                arrayResponse.push(addUrl);
            });

            /** Energy consumption without kWh meter submit */
            if (checkValidArray(spOp4HourReportingCurrentReport) && values.withoutkWhMeter[0]?.id > 0) {
                values.withoutkWhMeter.forEach((val: any) => {
                    addUrl = apiGlobal.put(`/special_operation_4_hours_reporting/${val.id}/`, val);
                });
                arrayResponse.push(addUrl);
            } else {
                if (values.withoutkWhMeter?.length > 0) {
                    addUrl = apiGlobal.post('/special_operation_4_hours_reporting/', values.withoutkWhMeter);
                    arrayResponse.push(addUrl);
                }
            }
        }

        /** Special Operation logbook */
        if (checkValidObject(values?.logBook)) {
            values.logBook.special_operation = checkValidArray(SpecialOpsObject) ? SpecialOpsObject[0]?.id : null;
        }
        if (spOpConstant !== SpecialOpsConstant.REEFER_CONTAINER) {
            if (values.logBook?.id) {
                const formData = new FormData();
                Object.keys(values.logBook).forEach((item: any) => {
                    if (values.logBook[item] !== null && values.logBook[item] !== undefined) {
                        formData.append(item, values.logBook[item]);
                    }
                });
                if (logBookFile?.[0]?.file) {
                    formData.set("file_name", logBookFile[0].file);
                } else {
                    formData.delete("file_name");
                }
                addUrl = apiMedia.put(`/special_operation_file_upload/${values.logBook.id}/`, formData);
                arrayResponse.push(addUrl);
            } else if (checkValidArray(logBookFile)) {
                const formData = new FormData();
                Object.keys(values.logBook).forEach((item: any) => {
                    if (values.logBook[item] !== null && values.logBook[item] !== undefined) {
                        formData.append(item, values.logBook[item]);
                    }
                });
                if (logBookFile?.[0]?.file) {
                    formData.set("file_name", logBookFile[0].file);
                } else {
                    formData.delete("file_name");
                }
                addUrl = apiMedia.post(`/special_operation_file_upload/`, formData)
                    .then(async (res: any) => {
                        if (res.status === 201) {
                            values.logBook = res.data;
                            setLogBookFile([]);
                        }
                    });
                arrayResponse.push(addUrl);
            }
        }

        /** Reefer special case */
        if (spOpConstant === SpecialOpsConstant.REEFER_CONTAINER) {
            if (!(machineryFuelGroup && machineryFuelGroup?.length > 0) &&
                !(withkWhMeter && withkWhMeter?.length > 0) &&
                (withoutkWhMeter && withoutkWhMeter?.length > 0)) {
                if (env?.form_validation === true) {
                    setErrorMessage(null);
                    toggleDynamicTabs(previousEnggTabIndex + 1);
                }
            }
        }
        await handleServerResponse(arrayResponse)
            .then(async (res: any) => {
                if (res === true) {
                    await dispatch(getCurrentReportAction(VesselID, ReportID));
                    await dispatch(getCurrentReportFilesAction(ReportID, VesselID));
                    setFormRefresh(formRefresh + 1);
                    toggleDynamicTabs(previousEnggTabIndex + 1);
                } else {
                    setErrorMessage(res);
                }
            })
            .finally(() => {
                if (env?.form_validation === true) {
                    setErrorMessage(null);
                    actions.setSubmitting(false);
                }
            });
    };

    const loading = reportingLoading ||
        machineryFuelGroupLoading ||
        machineryEnergyGroupLoading ||
        TimePeriodLoading ||
        AuxEngineMaxSFOCLoading ||
        SpecialOpsObjectLoading ||
        fuelMachineQueryObj.variable === null ||
        fuelMachineQueryObj.loadVariable === null ||
        energyMachineQueryObj.variable === null ||
        energyMachineQueryObj.loadVariable === null

    const error = reportingError ||
        machineryFuelGroupError ||
        machineryEnergyGroupError ||
        TimePeriodError ||
        AuxEngineMaxSFOCError ||
        SpecialOpsObjectError

    if (loading) {
        return <Loading message='Loading required data!' />
    }

    if (error) {
        return <ErrorComponent message='Unable to load required data!' />
    }

    return (
        <Card className='p-0 mb-0 '>
            <CardHeader className='p-2'>
                <div className="text-center">
                    <Row>
                        <Col>
                            <h4 className="page_title pos-start mb-0">Special Operation - {Operation}</h4>
                            <p className="card-title-desc pos-start">All readings since last report</p>
                        </Col>
                        <Col>
                            <ReportDetailsHeader />
                        </Col>
                    </Row>
                </div>
            </CardHeader>
            {
                !(loading) &&
                !(error) &&
                <Formik
                    onSubmit={async (values: any, actions: any) => {
                        if (!logBookFile[0].file && (env?.form_validation === false || isFormUnchanged(SpecialOperationFormik.initialValues, values))) {
                            setErrorMessage(null)
                            toggleDynamicTabs(previousEnggTabIndex + 1);
                            return;
                        }
                        actions.setSubmitting(true);
                        await specialOperationSubmit(values, actions);
                    }}
                    initialValues={SpecialOperationFormik.initialValues}
                    validationSchema={env?.form_validation ? SpecialOperationFormik.validationScehma : null}
                    key={formRefresh}
                >
                    {({ initialValues, values, errors, handleSubmit, handleChange, isSubmitting, setFieldValue, resetForm, setErrors, validateForm, setFieldTouched }:
                        { initialValues: any, values: any, errors: any, handleSubmit: any, handleChange: any, touched: any, isSubmitting: any, setFieldValue: any, resetForm: any, setErrors: any, isValid: any, validateForm: any, setFieldTouched: any; }) => (
                        <Form autoComplete="off" onSubmit={handleSubmit} noValidate>
                            <CardBody className='p-0'>
                                <Row className='px-2'>
                                    {spOpConstant !== SpecialOpsConstant.REEFER_CONTAINER && !editReportBool &&
                                        <Card className='m-0 p-0 rounded-0'>
                                            <CardHeader className='py-2'>
                                                <Row><h4 className='p-0 m-0'>Log Book Upload</h4></Row>
                                            </CardHeader>
                                            <CardBody className="px-2 pb-2 pt-0 mt-0">
                                                <ReportingFileUpload
                                                    setFile={setLogBookFile}
                                                    file={logBookFile}
                                                    fileUploadStatus={specialOperationFileUpload?.status === FileStatus.UPLOADED}
                                                    fileURL={specialOperationFileUpload?.file_path}
                                                    deleteURL={`/special_operation_file_upload/`}
                                                    invalidateQuery={null}
                                                    deleteID={specialOperationFileUpload?.id}
                                                    refreshKey={refreshKey}
                                                    setRefreshKey={setRefreshKey}
                                                    title={''}
                                                    DeleteFileObj={DeleteFileObj}
                                                    index={0}
                                                    cssModule='pt-0'
                                                />
                                            </CardBody>
                                        </Card>
                                    }
                                </Row>
                                {
                                    (machineryFuelGroup && machineryFuelGroup?.length > 0) &&
                                    <Row className='px-2'>
                                        <Card className='mb-0 rounded-0 border-bottom-0'>
                                            <CardHeader className='p-2'>
                                                <div className="text-center">
                                                    <Row>
                                                        <Col className='ps-0'>
                                                            <h4 className="page_title pos-start mb-0">Fuel Consumption</h4>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </CardHeader>
                                            <CardBody className="p-0">
                                                <div className="table-responsive">
                                                    <table className="table mb-0">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th className='p-2 sr-no-width align-middle'>#</th>
                                                                <th className="p-2 align-middle">Machinery name</th>
                                                                {
                                                                    fuelTypes && fuelTypes?.map((fuelType: any, index: number) => {
                                                                        return (
                                                                            <th key={index} className="p-2 align-middle asteric text-center">{fuelType.fuel_type_name}</th>
                                                                        )
                                                                    })
                                                                }
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {machineryFuelGroup.map((vesselMachinery: any, index: number) => {
                                                                return (
                                                                    <tr key={vesselMachinery.id}>
                                                                        <td className='p-2 align-middle text-center'>{index + 1}</td>
                                                                        <td className='p-2 align-middle'>{vesselMachinery.vessel_machinery_fc_group_name}</td>
                                                                        <FieldArray name='fuelConsumption'>
                                                                            {() => (
                                                                                <React.Fragment>
                                                                                    {values?.fuelConsumption?.filter((item: any) => item.vessel_machinery_fc_group === vesselMachinery.vessel_machinery_fc_group && item.special_operation === spOpConstant)
                                                                                        .map((fuelConsumptions: any, index: number) => {
                                                                                            return (
                                                                                                <td key={index} className='p-2 text-center align-middle'>
                                                                                                    <SpOpFuelConsumptionComponent
                                                                                                        fuelConsumptions={fuelConsumptions}
                                                                                                        machineryEnabled={machineryEnabled(
                                                                                                            fuelSettings,
                                                                                                            VesselID,
                                                                                                            fuelConsumptions?.vessel_machinery_fc_group,
                                                                                                            fuelConsumptions?.fuel_type
                                                                                                        )}
                                                                                                        editValues={editValues}
                                                                                                        setEditValues={setEditValues}
                                                                                                        revPopup={modal_backdrop}
                                                                                                        spOpConstant={spOpConstant}
                                                                                                    />
                                                                                                </td>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </React.Fragment>
                                                                            )}
                                                                        </FieldArray>
                                                                    </tr>
                                                                )
                                                            })
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Row>
                                }
                                {(withkWhMeter && withkWhMeter?.length > 0) &&
                                    <Row className='px-2'>
                                        <Card className='mb-0  rounded-0 border-bottom-0'>
                                            <CardHeader className='p-2'>
                                                <div className="text-center">
                                                    <Row>
                                                        <Col className='ps-0'>
                                                            <h4 className=" pos-start mb-0">Energy Consumption</h4>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </CardHeader>
                                            <div className="table-responsive">
                                                <table className="table mb-0">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th className="sr-no-width align-middle p-2">#</th>
                                                            <th className="align-middle p-2">Machinery name</th>
                                                            <th className="align-middle asteric text-center p-2">Energy consumed</th>
                                                            <th className="align-middle text-center  p-2">Equivalent fuel consumption</th>
                                                            <th className="align-middle text-center  p-2">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {withkWhMeter.map((vesselMachinery: any) => {
                                                            return (
                                                                <FieldArray name='functional'>
                                                                    {() => (
                                                                        <React.Fragment>
                                                                            {values?.withkWhMeter.functional
                                                                                .filter((item: any) => item.vessel_machinery_ec_group === vesselMachinery.vessel_machinery_ec_group && item.special_operation === spOpConstant)
                                                                                .map((energyConsumptions: any, index: number) => {
                                                                                    return (
                                                                                        <tr key={vesselMachinery.id}>
                                                                                            <td className='p-2 align-middle text-center align-middle'>{index + 1}</td>
                                                                                            <td className='p-2 align-middle'>{vesselMachinery.vessel_machinery_ec_group_name}</td>
                                                                                            <td className='p-2 align-middle text-center'>
                                                                                                <SpOpEnergyConsumptionComponent
                                                                                                    energyConsumptions={energyConsumptions}
                                                                                                    handleChange={handleChange}
                                                                                                    AuxEngineMaxSFOC={AuxEngineMaxSFOC}
                                                                                                    kwhMeterPopup={modal_backdrop}
                                                                                                    editValues={editValues}
                                                                                                    setEditValues={setEditValues}
                                                                                                    spOpConstant={spOpConstant}
                                                                                                />
                                                                                            </td>
                                                                                            <td className='p-2 text-center align-middle'>
                                                                                                <Label>
                                                                                                    {Number.isNaN(parseFloat((AuxEngineMaxSFOC.max_eedi_eexi_technical_file *
                                                                                                        values.withkWhMeter.functional[values.withkWhMeter.functional.indexOf(energyConsumptions)].energy_consumed / 1000000).toFixed(4))) ? "0.0000" :
                                                                                                        (AuxEngineMaxSFOC.max_eedi_eexi_technical_file *
                                                                                                            values.withkWhMeter.functional[values.withkWhMeter.functional.indexOf(energyConsumptions)].energy_consumed / 1000000).toFixed(4)}</Label>
                                                                                            </td>
                                                                                            <td className="p-2 align-middle text-center">
                                                                                                <Button
                                                                                                    className={`btn ${values.withkWhMeter.functional[values.withkWhMeter.functional.indexOf(energyConsumptions)]?.is_kwh_meter_not_functional === true ?
                                                                                                        'btn-danger' : 'functional-status-color'} btn_size_8_cstm`}
                                                                                                    onClick={() => {
                                                                                                        setModalMachinery(vesselMachinery);
                                                                                                        setModalIndex(values.withkWhMeter.functional.indexOf(energyConsumptions));
                                                                                                        tog_backdrop();
                                                                                                    }}
                                                                                                >
                                                                                                    Sensor failure
                                                                                                </Button>
                                                                                                <Modal
                                                                                                    isOpen={modal_backdrop}
                                                                                                    toggle={() => {
                                                                                                        tog_backdrop();
                                                                                                    }}
                                                                                                    backdrop={"static"}
                                                                                                    id="staticBackdrop"
                                                                                                    size={values.withkWhMeter.functional[modalIndex]?.is_kwh_meter_not_functional === true
                                                                                                        && values?.withkWhMeter?.nonfunctional?.length > 0 ? 'xl' : 'md'}
                                                                                                >
                                                                                                    <div className="modal-header">
                                                                                                        <h5 className="modal-title text-center" id="staticBackdropLabel">
                                                                                                            Action
                                                                                                        </h5>
                                                                                                    </div>
                                                                                                    <div className="modal-body">
                                                                                                        <strong>Please Note -</strong>
                                                                                                        <p>{TooltipMsg.Special_Operations
                                                                                                            .filter((item: any) => item.target ===
                                                                                                                'is_kWh_meter_functional_msg')
                                                                                                            .map((tool: any) => { return tool.message })}</p>
                                                                                                        <div className="d-flex flex-wrap gap-2 align-items-center">
                                                                                                            <Label htmlFor={`withkWhMeter.functional.${modalIndex}.is_kwh_meter_not_functional`}>
                                                                                                                kWh meter failure?
                                                                                                            </Label>
                                                                                                            <div className="square-switch sqswitch d-flex align-items-center">
                                                                                                                <Field name={`withkWhMeter.functional.${modalIndex}.is_kwh_meter_not_functional`}>
                                                                                                                    {({ field }: FieldProps) => (
                                                                                                                        <Input
                                                                                                                            onFocus={(e) => e.target.select()}
                                                                                                                            type="checkbox"
                                                                                                                            switch="none"
                                                                                                                            name={field.name}
                                                                                                                            id={field.name}
                                                                                                                            onChange={(e: any) => {
                                                                                                                                handleChange(e);
                                                                                                                                if (e.target.checked === true) {
                                                                                                                                    setFieldValue(
                                                                                                                                        `withkWhMeter.functional.${modalIndex}.energy_consumed`, 0);
                                                                                                                                    setFieldValue(
                                                                                                                                        `withkWhMeter.functional.${modalIndex}.equivalent_fuel_consumption`, 0);

                                                                                                                                } else {
                                                                                                                                    values?.withkWhMeter?.nonfunctional?.filter((item: any) =>
                                                                                                                                        item.vessel_machinery_ec_group === modalMachinery?.vessel_machinery_ec_group)?.forEach((time: any) => {
                                                                                                                                            setFieldValue(`withkWhMeter.nonfunctional.${values?.withkWhMeter?.nonfunctional?.indexOf(time)}.hours_of_consumption`, 0);
                                                                                                                                            setFieldValue(`withkWhMeter.nonfunctional.${values?.withkWhMeter?.nonfunctional?.indexOf(time)}.v`, 0);
                                                                                                                                            setFieldValue(`withkWhMeter.nonfunctional.${values?.withkWhMeter?.nonfunctional?.indexOf(time)}.i`, 0);
                                                                                                                                            setFieldValue(`withkWhMeter.nonfunctional.${values?.withkWhMeter?.nonfunctional?.indexOf(time)}.pf`, 0);
                                                                                                                                            setFieldValue(`withkWhMeter.nonfunctional.${values?.withkWhMeter?.nonfunctional?.indexOf(time)}.w`, 0);
                                                                                                                                        })
                                                                                                                                    setFieldValue(
                                                                                                                                        `withkWhMeter.functional.${modalIndex}.energy_consumed`, 0);
                                                                                                                                    setFieldValue(
                                                                                                                                        `withkWhMeter.functional.${modalIndex}.equivalent_fuel_consumption`, 0);
                                                                                                                                }
                                                                                                                            }}
                                                                                                                            checked={values.withkWhMeter.functional[modalIndex].is_kwh_meter_not_functional}
                                                                                                                        />
                                                                                                                    )}
                                                                                                                </Field>
                                                                                                                <Label htmlFor={`withkWhMeter.functional.${modalIndex}.is_kwh_meter_not_functional`}
                                                                                                                    data-on-label='Yes' data-off-label='No'>
                                                                                                                </Label>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        {(SpecialOpsObject && SpecialOpsObject[0]?.constant === SpecialOpsConstant.REEFER_CONTAINER &&
                                                                                                            values.withkWhMeter.functional[modalIndex]?.is_kwh_meter_not_functional === true) ?
                                                                                                            <Card className='mb-0'>
                                                                                                                <CardHeader className='p-2'>
                                                                                                                    <Row>
                                                                                                                        <Col className='ps-2'>
                                                                                                                            <h4 className="page_title mb-0">FC<sub>electrical_reefer</sub></h4>
                                                                                                                        </Col>
                                                                                                                    </Row>
                                                                                                                </CardHeader>
                                                                                                                <CardBody className="p-2">
                                                                                                                    <Row className='mb-2'>
                                                                                                                        <Col lg={4}>
                                                                                                                            <Label for="reefer_days_sea" className='mb-0'>Reefer days at sea
                                                                                                                                <i className='bx bx-info-circle ml-2p' id='reefer_days_sea_msg' />:
                                                                                                                            </Label>
                                                                                                                            <ToolTip target='reefer_days_sea_msg'
                                                                                                                                message={`${TooltipMsg.Reefer_Container
                                                                                                                                    .filter((item: any) => item.target === 'reefer_days_sea_msg')
                                                                                                                                    .map((tool: any) => { return tool.message })}`}
                                                                                                                            />
                                                                                                                            <strong>{values?.withkWhMeter?.nonfunctional[0]?.reefer_days_at_sea}</strong>
                                                                                                                        </Col>
                                                                                                                        <Col lg={4}>
                                                                                                                            <Label for="reefer_days_port" className='mb-0'>Reefer days in port
                                                                                                                                <i className='bx bx-info-circle ml-2p' id='reefer_days_port_msg' />:
                                                                                                                            </Label>
                                                                                                                            <ToolTip target='reefer_days_port_msg'
                                                                                                                                message={`${TooltipMsg.Reefer_Container
                                                                                                                                    .filter((item: any) => item.target === 'reefer_days_port_msg')
                                                                                                                                    .map((tool: any) => { return tool.message })}`}
                                                                                                                            />
                                                                                                                            <strong>{values?.withkWhMeter?.nonfunctional[0]?.reefer_days_in_port}</strong>
                                                                                                                        </Col>
                                                                                                                        <Col lg={4}>
                                                                                                                            <Label for="reefer_equivalent_fuel_consumption" className='mb-0'>Equivalent fuel consumption
                                                                                                                                <i className='bx bx-info-circle ml-2p' id='reefer_equivalent_fuel_consumption_msg' />:
                                                                                                                            </Label>
                                                                                                                            <ToolTip target='reefer_equivalent_fuel_consumption_msg'
                                                                                                                                message={`${TooltipMsg.Reefer_Container
                                                                                                                                    .filter((item: any) => item.target === 'reefer_equivalent_fuel_consumption_msg')
                                                                                                                                    .map((tool: any) => { return tool.message })}`}
                                                                                                                            />
                                                                                                                            <strong>{values?.withkWhMeter?.nonfunctional[0]?.equivalent_fuel_consumption}</strong>
                                                                                                                        </Col>
                                                                                                                    </Row>
                                                                                                                    <Row>
                                                                                                                        <Col lg={4}>
                                                                                                                            <Label for="fc_electrical" className='mb-0'>FC<sub>electrical_reefer</sub>
                                                                                                                                <i className='bx bx-info-circle ml-2p' id='fc_electrical_msg' />:
                                                                                                                            </Label>
                                                                                                                            <ToolTip target='fc_electrical_msg'
                                                                                                                                message={`${TooltipMsg.Reefer_Container
                                                                                                                                    .filter((item: any) => item.target === 'fc_electrical_msg')
                                                                                                                                    .map((tool: any) => { return tool.message })}`}
                                                                                                                            />
                                                                                                                            <strong>{values?.withkWhMeter?.nonfunctional[0]?.fc_electrical_reefer}</strong>
                                                                                                                        </Col>
                                                                                                                    </Row>
                                                                                                                </CardBody>
                                                                                                            </Card> :
                                                                                                            values?.withkWhMeter?.functional[modalIndex]?.is_kwh_meter_not_functional === true &&
                                                                                                            (values?.withkWhMeter?.nonfunctional?.length > 0 ?
                                                                                                                <FourHrTableComponent
                                                                                                                    vesselMachinery={modalMachinery}
                                                                                                                    tableHeader={'Hours of cargo cooling'}
                                                                                                                    valueName={'withkWhMeter.nonfunctional'}
                                                                                                                    valueSubName={values?.withkWhMeter?.nonfunctional}
                                                                                                                    initialSubName={initialValues?.withkWhMeter?.nonfunctional}
                                                                                                                    energyConsumedField={`withkWhMeter.functional[${modalIndex}].energy_consumed`}
                                                                                                                    showMachineryName={false}
                                                                                                                    applicableTimePeriod={applicableTimePeriod}
                                                                                                                    editValues={editValues}
                                                                                                                    revPopup={modal_backdrop}
                                                                                                                    setEditValues={setEditValues}
                                                                                                                    spOpConstant={spOpConstant}
                                                                                                                /> :
                                                                                                                <Row className='text-center'>
                                                                                                                    <h5 className='mb-0 label-red'>No valid time slots(4 hrs) available for this report!</h5>
                                                                                                                </Row>
                                                                                                            )
                                                                                                        }
                                                                                                    </div>
                                                                                                    <Row>
                                                                                                        <Col sm={{ size: 2, offset: 10 }}>
                                                                                                            <Button
                                                                                                                type="button"
                                                                                                                color="primary"
                                                                                                                className={`btn_size_cstm mb-2 ${values.withkWhMeter.functional[modalIndex]
                                                                                                                    ?.is_kwh_meter_not_functional === true ? "justify_right me-3" : ""}`}
                                                                                                                onClick={() => {
                                                                                                                    setmodal_backdrop(false);
                                                                                                                }}
                                                                                                                disabled={errors && errors?.withkWhMeter?.nonfunctional?.length > 0}
                                                                                                            >
                                                                                                                Ok
                                                                                                            </Button>
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                </Modal>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </React.Fragment>
                                                                    )}
                                                                </FieldArray>
                                                            )
                                                        })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Card>
                                    </Row>
                                }
                                {(withoutkWhMeter && withoutkWhMeter?.length > 0) &&
                                    (SpecialOpsObject && SpecialOpsObject[0]?.constant === SpecialOpsConstant.REEFER_CONTAINER) ?
                                    <Card className='mb-0 border-top-0 rounded-0 border-bottom-0'>
                                        <CardHeader className='p-2'>
                                            <Row>
                                                <Col className='ps-2'>
                                                    <h4 className="page_title mb-0">FC<sub>electrical_reefer</sub></h4>
                                                </Col>
                                            </Row>
                                        </CardHeader>
                                        <CardBody className="p-2">
                                            <Row className='mb-2'>
                                                <Col lg={4}>
                                                    <Label for="reefer_days_sea" className='mb-0'>Reefer days at sea
                                                        <i className='bx bx-info-circle ml-2p' id='reefer_days_sea_msg' />:
                                                    </Label>
                                                    <ToolTip target='reefer_days_sea_msg'
                                                        message={`${TooltipMsg.Reefer_Container
                                                            .filter((item: any) => item.target === 'reefer_days_sea_msg')
                                                            .map((tool: any) => { return tool.message })}`}
                                                    />
                                                    <strong>{values?.withkWhMeter?.nonfunctional[0]?.reefer_days_at_sea}</strong>
                                                </Col>
                                                <Col lg={4}>
                                                    <Label for="reefer_days_port" className='mb-0'>Reefer days in port
                                                        <i className='bx bx-info-circle ml-2p' id='reefer_days_port_msg' />:
                                                    </Label>
                                                    <ToolTip target='reefer_days_port_msg'
                                                        message={`${TooltipMsg.Reefer_Container
                                                            .filter((item: any) => item.target === 'reefer_days_port_msg')
                                                            .map((tool: any) => { return tool.message })}`}
                                                    />
                                                    <strong>{values?.withkWhMeter?.nonfunctional[0]?.reefer_days_in_port}</strong>
                                                </Col>
                                                <Col lg={4}>
                                                    <Label for="reefer_equivalent_fuel_consumption" className='mb-0'>Equivalent fuel consumption
                                                        <i className='bx bx-info-circle ml-2p' id='reefer_equivalent_fuel_consumption_msg' />:
                                                    </Label>
                                                    <ToolTip target='reefer_equivalent_fuel_consumption_msg'
                                                        message={`${TooltipMsg.Reefer_Container
                                                            .filter((item: any) => item.target === 'reefer_equivalent_fuel_consumption_msg')
                                                            .map((tool: any) => { return tool.message })}`}
                                                    />
                                                    <strong>{values?.withkWhMeter?.nonfunctional[0]?.equivalent_fuel_consumption}</strong>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={4}>
                                                    <Label for="fc_electrical" className='mb-0'>FC<sub>electrical_reefer</sub>
                                                        <i className='bx bx-info-circle ml-2p' id='fc_electrical_msg' />:
                                                    </Label>
                                                    <ToolTip target='fc_electrical_msg'
                                                        message={`${TooltipMsg.Reefer_Container
                                                            .filter((item: any) => item.target === 'fc_electrical_msg')
                                                            .map((tool: any) => { return tool.message })}`}
                                                    />
                                                    <strong>{values?.withkWhMeter?.nonfunctional[0]?.fc_electrical_reefer}</strong>
                                                </Col>
                                            </Row>
                                            <Row className='mt-3 mb-2'>
                                                <strong className='mb-0'>Please Note:{" "}</strong><p className='mb-0'>
                                                    Since the Reefer container power supply panel is not equipped with a kWh meter, the <strong className='mb-0'>FC<sub>electrical_reefer</sub></strong>
                                                    &nbsp; will be calculated based on the number of reefer containers onboard and the empirical formula provided in
                                                    <strong className='mb-0'>&nbsp;MEPC 355/78</strong> :
                                                </p>
                                            </Row>
                                            <Row>
                                                <h5 className='mb-0'>FC<sub>electrical_reefer, j</sub> = Cx * 24 SFOC<sub>avg</sub> * (Reefer_days<sub>sea</sub> + ∑Reefer_days<sub>port</sub>)</h5>
                                            </Row>
                                        </CardBody>
                                    </Card> :
                                    (withoutkWhMeter && withoutkWhMeter?.length > 0) &&
                                        (SpecialOpsObject && SpecialOpsObject[0]?.constant !== SpecialOpsConstant.REEFER_CONTAINER) ?
                                        <Row className='px-2'>
                                            <Card className='mb-0 border-top-0 rounded-0 border-bottom-0'>
                                                <CardHeader className='p-2'>
                                                    <div className="text-center">
                                                        <Row>
                                                            <Col className='ps-0'>
                                                                <h4 className="page_title pos-start mb-0">Electrical Energy Consumption without kWh Meter</h4>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </CardHeader>
                                                {initialValues?.withoutkWhMeter && values?.withoutkWhMeter ? withoutkWhMeter.map((vesselMachinery: any) => {
                                                    return (
                                                        <FourHrTableComponent
                                                            vesselMachinery={vesselMachinery}
                                                            tableHeader={FourHrTblHeader}
                                                            valueName={'withoutkWhMeter'}
                                                            valueSubName={values?.withoutkWhMeter}
                                                            initialSubName={initialValues?.withoutkWhMeter}
                                                            showMachineryName={true}
                                                            energyConsumedField={''}
                                                            applicableTimePeriod={applicableTimePeriod}
                                                            editValues={editValues}
                                                            setEditValues={setEditValues}
                                                            spOpConstant={spOpConstant}
                                                        />
                                                    )
                                                })
                                                    :
                                                    <div className='mb-2'>
                                                        <Message
                                                            message="The 4-hour table is not applicable, as the time interval between the last report and the current report does not fall within the prescribed rule."
                                                            type="warning"
                                                        />
                                                    </div>
                                                }
                                            </Card>
                                        </Row> :
                                        null
                                }
                            </CardBody>
                            <CardFooter className="p-2 py-3">
                                <Row className="d-flex align-items-center flex-row-reverse">
                                    <Col lg={10}>
                                        <div className="d-flex flex-wrap gap-3 justify_right">
                                            {/* {editReportBool &&
                                                <Button
                                                    type="reset"
                                                    color="danger"
                                                    className="btn_size_cstm"
                                                    onClick={() => {
                                                        setEditValues({
                                                            ...editValues,
                                                            chief_engineer: {
                                                                ...editValues?.chief_engineer,
                                                                special_operation_fuel: editInitialValues?.chief_engineer?.special_operation_fuel,
                                                                special_operation_sub_type_fc: editInitialValues?.chief_engineer?.special_operation_sub_type_fc,
                                                                special_operation_energy: editInitialValues?.chief_engineer?.special_operation_energy,
                                                                special_operation_4_hours_reporting: editInitialValues?.chief_engineer?.special_operation_4_hours_reporting,
                                                            }
                                                        })
                                                        setRefreshKey(refreshKey + 1);
                                                        setFormRefresh(formRefresh + 1);
                                                    }}
                                                >
                                                    Reset
                                                </Button>
                                            } */}
                                            <Button
                                                type={editReportBool ? "button" : "submit"}
                                                color="primary"
                                                className="btn_size_cstm"
                                                disabled={isSubmitting || editIsSubmitting}
                                                onClick={async () => {
                                                    const validationErrors = await validateForm();

                                                    // Helpers
                                                    const touchArray = (basePath: string, arr: any[] = []) => {
                                                        arr.forEach((item, idx) => {
                                                            Object.keys(item ?? {}).forEach((field) => {
                                                                setFieldTouched(`${basePath}[${idx}].${field}`, true, false);
                                                            });
                                                        });
                                                    };
                                                    const touchObject = (basePath: string, obj: any = {}) => {
                                                        Object.keys(obj ?? {}).forEach((field) => {
                                                            setFieldTouched(`${basePath}.${field}`, true, false);
                                                        });
                                                    };

                                                    // fuelConsumption[]
                                                    touchArray("fuelConsumption", values.fuelConsumption);

                                                    // logBook {}
                                                    touchObject("logBook", values.logBook);

                                                    // withkWhMeter.functional[] & withkWhMeter.nonfunctional[]
                                                    touchArray(
                                                        "withkWhMeter.functional",
                                                        values.withkWhMeter?.functional
                                                    );
                                                    touchArray(
                                                        "withkWhMeter.nonfunctional",
                                                        values.withkWhMeter?.nonfunctional
                                                    );

                                                    // withoutkWhMeter[]
                                                    touchArray("withoutkWhMeter", values.withoutkWhMeter);

                                                    // proceed only if valid
                                                    if (editReportBool && Object.keys(validationErrors).length === 0) {
                                                        await saveEditForm(
                                                            editSubmit,
                                                            toggleDynamicTabs,
                                                            previousEnggTabIndex,
                                                            setPreviousTabIndex
                                                        );
                                                    }
                                                }}
                                            >
                                                {(isSubmitting || editIsSubmitting) && (
                                                    <i className="ms-2 spinner-border spinner-border-sm text-light me-2" />
                                                )}
                                                Next <i className="bx bx-chevron-right ms-1" />
                                            </Button>
                                        </div>
                                    </Col>
                                    <Col lg={2}>
                                        <Button
                                            type="button"  // Change from "submit" to "button"
                                            color="primary"
                                            className="btn_size_cstm"
                                            onClick={() => {
                                                setErrorMessage(null);
                                                setErrors({});
                                                resetForm();
                                                toggleDynamicTabs(previousEnggTabIndex - 1);
                                            }}
                                        >
                                            <i className="bx bx-chevron-left me-1" /> Previous
                                        </Button>
                                    </Col>
                                </Row>
                            </CardFooter>
                            <FormValuesDebug values={[values, errors, SpecialOperationFormik.initialValues]} />
                        </Form>
                    )}
                </Formik>
            }
        </Card >
    )
}

export default SpecialOperationComponent
